module.exports = __webpack_public_path__ + "static/media/womensday.48042155.JPG";